export const navLinks = [
  { label: 'Product', sectionId: 'product' },
  { label: 'Security', sectionId: 'security' },
  { label: 'Discharge', sectionId: 'discharge' },
  { label: 'Vision', sectionId: 'vision' },
  { label: 'News', sectionId: 'news' },
  { label: 'Team', sectionId: 'team' },
] as const;
